import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useBlogCatalog } from '../data/blogCatalog';
import BlogSearch from '../components/BlogSearch';
import '../styles/Blog.css';

function Blog() {
  const navigate = useNavigate();
  const { posts, categories, loading } = useBlogCatalog();
  const [filteredPosts, setFilteredPosts] = useState(posts);
  const [selectedLawType, setSelectedLawType] = useState('All');
  const [searchResults, setSearchResults] = useState(posts);

  useEffect(() => {
    setSearchResults(posts);
    if (selectedLawType === 'All') {
      setFilteredPosts(posts);
    } else {
      setFilteredPosts(posts.filter((post) => post.category === selectedLawType));
    }
  }, [posts, selectedLawType]);

  const handleSearchResults = (results) => {
    setSearchResults(results);
    if (selectedLawType !== 'All') {
      setFilteredPosts(results.filter((post) => post.category === selectedLawType));
    } else {
      setFilteredPosts(results);
    }
  };

  const handleLawTypeFilter = (lawType) => {
    setSelectedLawType(lawType);
    if (lawType === 'All') {
      setFilteredPosts(searchResults);
    } else {
      setFilteredPosts(searchResults.filter((post) => post.category === lawType));
    }
  };

  return (
    <div className="blog">
      <div className="law-type-filter">
        <div className="filter-buttons">
          <button
            className={`filter-btn ${selectedLawType === 'All' ? 'active' : ''}`}
            onClick={() => handleLawTypeFilter('All')}
            type="button"
          >
            All Articles
          </button>
          {categories.map((lawType) => (
            <button
              key={lawType}
              type="button"
              className={`filter-btn ${selectedLawType === lawType ? 'active' : ''}`}
              onClick={() => handleLawTypeFilter(lawType)}
            >
              {lawType}
            </button>
          ))}
        </div>
      </div>

      <BlogSearch posts={posts} onSearchResults={handleSearchResults} />

      {loading ? (
        <p className="blog-loading">Updating articles…</p>
      ) : null}

      <div className="blog-posts">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <article
              key={post.slug}
              className="blog-post"
              onClick={() => {
                navigate(`/blog/${post.slug}`);
              }}
            >
              <div className="post-meta">
                <span className="post-category">{post.category}</span>
                <span className="post-date">{post.date}</span>
              </div>
              <h2 className="post-title">
                <Link to={`/blog/${post.slug}`} onClick={(e) => e.stopPropagation()}>
                  {post.title}
                </Link>
              </h2>
              <p className="post-excerpt">{post.excerpt}</p>
              <div className="post-footer">
                <span className="post-author">By {post.author}</span>
                <Link
                  to={`/blog/${post.slug}`}
                  className="read-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Read More →
                </Link>
              </div>
            </article>
          ))
        ) : (
          <div className="no-posts">
            <h3>No articles found</h3>
            <p>Try adjusting your search or filter criteria.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Blog;
